import { useEffect, useRef } from "react";

// runAgent の onEvent を時系列リスト表示する折りたたみセクション（チャットパネル内）。
function ExecutionLog({ logs }) {
  const listRef = useRef(null);

  useEffect(() => {
    const list = listRef.current;
    if (list) list.scrollTop = list.scrollHeight;
  }, [logs]);

  return (
    <details className="exec-log">
      <summary>実行ログ（{logs.length}）</summary>
      {logs.length === 0 ? (
        <p className="privacy-note">ツール実行や API 呼び出しの履歴が表示されます。</p>
      ) : (
        <ol className="log-list" ref={listRef}>
          {logs.map((log) => (
            <li key={log.id}>{log.message}</li>
          ))}
        </ol>
      )}
    </details>
  );
}

export default ExecutionLog;
